"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ image }) => {
    const theme = (0, material_1.useTheme)();
    const categoryCardStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
        width: '100%',
    };
    const descriptionStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
        gap: '8px',
        borderRadius: image ? '0px 0px 8px 8px' : '8px',
        width: '100%',
    };
    const categoryNameStyle = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { fontFamily: 'inherit', color: theme.qlub.palette.onSurfaceColors.highEmphasis });
    const descriptionTextStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { fontFamily: 'inherit', display: 'flex', alignItems: 'center', letterSpacing: '0.004em', color: theme.qlub.palette.onSurfaceColors.mediumEmphasis });
    const infoBox = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: '4px',
    };
    const iconStyle = {
        width: '20px',
        height: '20px',
        color: theme.qlub.palette.iris.main,
    };
    const infoStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.iris.main, display: 'flex', fontFamily: 'inherit', alignItems: 'center', letterSpacing: '0.004em' });
    const imgStyle = {
        borderRadius: '8px 8px 0px 0px',
        maxHeight: '200px',
    };
    return {
        categoryCardStyle,
        descriptionStyle,
        categoryNameStyle,
        descriptionTextStyle,
        infoBox,
        iconStyle,
        infoStyle,
        imgStyle,
    };
};
exports.default = useStyle;
